import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MetaService } from '../../meta.service';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule]
})
export default class CookiesComponent {
  meta = inject(MetaService);
  constructor() {
    this.meta.setTags('cloudigo Malta - Cookie Policy');
  }

}
